import {makeStyles} from "@material-ui/core/styles";

export const useTableWithCheckboxesStyles = makeStyles((theme) => ({
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    }
}));
